
import { IonButton, IonButtons, IonText } from '@ionic/react';

import EndImg from '@/assets/imgs/end/endImage.svg';
import styles from './End.module.scss';
interface EndProps {

  handleClose: () => void;
}

export default function End({ handleClose }: EndProps) {
  const selectLowerText = () => {
    const lowerText = 'Ya hemos ordenado el abono de esta operación, recibirás todos los detalles por correo electrónico. Recuerda que al final del día recibirás un email con los detalles de liquidación de las operaciones tramitadas hoy.';
    return lowerText;
  };

  return (
    <>
      <div className={styles.endWrapper}>
        <IonText className={styles.endTitle}>¡Gracias!</IonText>
        <div className={styles.endText}>
          Indícale a tu cliente que le hemos enviado un email con toda la documentación de su financiación. En la
          {' '}
          <span className={styles.textPepperColor}> App Pepper Clientes</span>
          , disponible en las principales stores, puede consultar el detalle y estado de sus financiaciones.
        </div>
        <img className={styles.endImage} src={EndImg} alt="End" />
        <div className={styles.endText}>
          {selectLowerText()}
        </div>
      </div>
      <IonButtons className={styles.nextBtnWrapper}>
        <IonButton className="nextButton" id="end-close-button" onClick={() => handleClose()}>Cerrar</IonButton>
      </IonButtons>
    </>
  );
}
